// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hvli","title":"styles_title__307BK"};